import { c as _c } from "react/compiler-runtime";
import type { LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Centered empty/info state — an icon, a headline, an optional hint, and an
// optional action. Reused by cart, wishlist, search, and 404.
export function EmptyState(t0) {
  const $ = _c(16);
  const {
    icon: Icon,
    title,
    hint,
    action,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col items-center gap-3 py-16 text-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Icon) {
    t2 = Icon && <span className="flex size-16 items-center justify-center rounded-full bg-osmix-gray-100 text-osmix-icon"><Icon className="size-8" /></span>;
    $[2] = Icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <span className="type-h3-bold text-osmix-text-1">{title}</span>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hint) {
    t4 = hint && <p className="max-w-sm type-body2 text-osmix-text-2">{hint}</p>;
    $[6] = hint;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== action) {
    t5 = action && <div className="mt-2">{action}</div>;
    $[8] = action;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t4}{t5}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}

// Error state with a retry button. `onRetry` typically wraps a query refetch.
export function ErrorState(t0) {
  const $ = _c(10);
  const {
    onRetry
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("common.error");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="type-h3-bold text-osmix-text-1">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onRetry || $[5] !== t) {
    t3 = onRetry && <Button variant="gray" size="md" onClick={onRetry}>{t("common.retry")}</Button>;
    $[4] = onRetry;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-col items-center gap-3 py-16 text-center">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}